import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

export const NG_APP_FEATURE_KEY = 'ngApp';

export interface SectionState {
  dismissed: boolean;
  expanded: boolean;
}

export interface AppState {
  searchQuery: string;
  homeShowMore: boolean;
  sectionState: Record<string, SectionState>;
}

export const setSearchQuery = createAction<string>('SET_SEARCH_QUERY');

export const addDismissedSection = createAction<string>('ADD_DISMISSED_SECTION');
export const removeDismissedSection = createAction<string>('REMOVE_DISMISSED_SECTION');

export const toggleSectionExpanded = createAction<string>('TOGGLE_SECTION_EXPANDED');
export const toggleHomeShowMore = createAction<string>('TOGGLE_HOME_SHOW_MORE');

export const initialState: AppState = {
  searchQuery: '',
  sectionState: {},
  homeShowMore: false,
};

export const ngAppSlice = createSlice({
  name: NG_APP_FEATURE_KEY,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setSearchQuery, (state, action) => {
      state.searchQuery = action?.payload || '';
    });

    builder.addCase(toggleHomeShowMore, (state) => {
      state.homeShowMore = !state.homeShowMore;
    });

    builder.addCase(addDismissedSection, (state, action: PayloadAction<string>) => {
      const key = action.payload;
      if (!key) return;

      const existing = state.sectionState[key];
      if (existing) {
        existing.dismissed = true;
      } else {
        state.sectionState[key] = { dismissed: true, expanded: false };
      }
    });

    builder.addCase(removeDismissedSection, (state, action: PayloadAction<string>) => {
      const key = action.payload;
      if (!key) return;

      const existing = state.sectionState[key];
      if (existing) {
        existing.dismissed = false;
      } else {
        state.sectionState[key] = { dismissed: false, expanded: false };
      }
    });

    builder.addCase(toggleSectionExpanded, (state, action: PayloadAction<string>) => {
      const key = action.payload;
      if (!key) return;

      const existing = state.sectionState[key];
      if (existing) {
        existing.expanded = !existing.expanded;
      } else {
        state.sectionState[key] = { dismissed: false, expanded: true };
      }
    });
  },
});


export const assetManagerUIReducer = ngAppSlice.reducer;

export const getNgAppState = (rootState: any): AppState => rootState[NG_APP_FEATURE_KEY];

export const ngAppSelectors = {
  getSearchQuery: (state: any) => getNgAppState(state).searchQuery,
  isSectionDismissed: (state: any, key: string): boolean => {
    const section = getNgAppState(state).sectionState[key];
    return section ? section.dismissed : false;
  },

  isSectionExpanded: (state: any, key: string): boolean => {
    const section = getNgAppState(state).sectionState[key];
    return section ? section.expanded : true;
  },

  isHomeShowMore: (state: any): boolean =>
    getNgAppState(state).homeShowMore,
};
